import axios from "@/plugins/axios";

export function getHitokoto() {
  return axios({
    url: "https://v1.hitokoto.cn/?c=a",
    method: "GET",
  });
}

export function getSite() {
  return axios({
    url: "Site/GetSiteSettingsAsync",
    method: "GET",
  });
}

export function getRandomArticle() {
  return axios({
    url: "Article/GetRandomArticleAsync",
    method: "GET",
  });
}

export function getNewArticle() {
  return axios({
    url: "Article/GetNewArticleList",
    method: "GET",
  });
}

export function getDataStatistics() {
  return axios({
    url: "Site/GetDataStatistics",
    method: "GET",
  });
}

export function getBlogUserInfoAsync() {
  return axios({
    url: "Site/GetBlogUserInfoAsync",
    method: "GET",
  });
}

export function GetDataStatisticsAndUserInfo() {
  return axios({
    url: "Site/GetDataStatisticsAndUserInfo",
    method: "GET",
  });
}
